import { createAction } from 'redux-actions';

export default {
    AddToCurrentState: createAction('ADD_TO_CURRENT_STATE'),
    UpdateRoadCfg: createAction('UPDATE_ROAD_CFG'),
    UpdateStandardsCfg: createAction('UPDATE_STANDARDS_CFG'),
    UpdateRoadSurface: createAction('UPDATE_ROAD_SURFACE'),

};
